import { useSyncExternalStore } from "react";

/**
 * A phone (03 §layout): narrower than Tailwind's `md`, where one column shows at a time.
 *
 * A hook rather than only CSS, because on a phone the screens are built differently rather than squeezed: the tabs
 * move to the bottom, the Studio's post list becomes a drawer, and the chat and its pane take turns. A browser
 * without `matchMedia` — jsdom, in the tests — reads as a desk, which is what every test before this one assumed.
 */
export const NARROW = "(max-width: 767px)";

const query = () => (typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(NARROW) : null);

export function useNarrow(): boolean {
  return useSyncExternalStore(
    (changed) => {
      const q = query();
      q?.addEventListener?.("change", changed);
      return () => q?.removeEventListener?.("change", changed);
    },
    () => query()?.matches ?? false,
    () => false,
  );
}
